import { render } from "./Mplus.vue?vue&type=template&id=26cf656c"
import script from "./Mplus.vue?vue&type=script&lang=js"
export * from "./Mplus.vue?vue&type=script&lang=js"
script.render = render

export default script